import * as yup from 'yup';

export const InvestSchema = (minAmount: number) =>
  yup.object({
    amount: yup.number().min(minAmount),
    investmentDoneAs: yup.string().required(),
    legalEntityId: yup.number().nullable(),
  });
